import 'css-chunksrc/client/pages/projectPage/documentsPage/styles.scss';export default {
  "documentsPage": "_documentsPage_r6ps2_1"
};